import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export type BankSettings = {
  enabled: boolean;
  bank_name: string;
  account_name: string;
  account_number: string;
  iban: string;
  swift: string;
  qr_image_url: string;
  instructions: string;
  duration_days: number;
};

const defaults: BankSettings = {
  enabled: true,
  bank_name: "",
  account_name: "",
  account_number: "",
  iban: "",
  swift: "",
  qr_image_url: "",
  instructions: "",
  duration_days: 30,
};

export function useBankSettings() {
  const [settings, setSettings] = useState<BankSettings>(defaults);
  const [loading, setLoading] = useState(true);

  const refetch = async () => {
    const { data } = await supabase
      .from("app_settings")
      .select("value")
      .eq("key", "bank_payment")
      .maybeSingle();
    if (data?.value) setSettings({ ...defaults, ...(data.value as any) });
    setLoading(false);
  };

  useEffect(() => {
    refetch();
  }, []);

  return { settings, loading, refetch };
}
